import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-梯口",
  "use": "icon-梯口-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-梯口\">\r\n<path d=\"M192,9.5v15.9l-21.3,10.3v72.6H192v11.7h-36.1v18.5h-40V159H74.4v18.4l-41.1-0.2v13.4H21.7v-24.8h20.7V97.4l-21.8,10.6v16.8\r\n\tH8v-24.4L192,9.5L192,9.5z M82.7,78L49.9,93.7v72h13.4v-18.4h19.4V78z M123,58.6L90.2,74.3v72.9h14.6v-20.5H123V58.6z M163.1,39.2\r\n\tL130.4,55v71.8h14.3v-18.5h18.4V39.2z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/梯口.svg
// module id = is4G
// module chunks = 15